import { OpenDaysDTO } from "../types/open-days-dto";

export const getOrganizationOpenDateOutput = (openDay: OpenDaysDTO): string => {
    const date = openDay.date;
    const day = date.getDate();
    const monthIndex = date.getMonth();

    const monthNames = [
        'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
        'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
    ];
    const month = monthNames[monthIndex];

    const dateStr = `${day} ${month}`;
    const start = openDay.startTime;
    const end = openDay.endTime;

    if(start && end) return `${dateStr} с ${start} до ${end}`;
    else if(start) return `${dateStr} в ${start}`;
    else return dateStr;
};

export const isTodayOrFuture = (value: Date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const date = new Date(value.getTime());
    date.setHours(0, 0, 0, 0);

    return date >= today;
};

export const getDayByNumber = (number: number) => {
    const days = [
        'Понедельник', 'Вторник', 'Среда', 
        'Четверг', 'Пятница', 'Суббота',
        'Воскресенье'
    ];

    return days[number];
};

const OMSK_TZ = 'Asia/Omsk';

type OmskNow = {
    dayIndex: number;
    hour: number;
    minute: number;
};

export function getOmskNow(): OmskNow {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: OMSK_TZ,
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
    }).formatToParts(new Date());

    const get = (type: string) => parts.find(p => p.type === type)?.value ?? '';

    const weekdayMap: Record<string, number> = {
        Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6,
    };

    return {
        dayIndex: weekdayMap[get('weekday')] ?? 0,
        hour: parseInt(get('hour'), 10),
        minute: parseInt(get('minute'), 10),
    };
}

type ScheduleStatus = {
    label: string;
    isOpen: boolean;
};

export function getScheduleStatus(schedule: readonly string[]): ScheduleStatus {
    const { dayIndex, hour, minute } = getOmskNow();
    const today = schedule[dayIndex];

    if(!today || today === 'Закрыто') {
        return { label: 'Закрыто', isOpen: false };
    }

    const [openStr, closeStr] = today.split('-');
    const [openH, openM] = openStr.split(':').map(Number);
    const [closeH, closeM] = closeStr.split(':').map(Number);

    const nowMin = hour * 60 + minute;
    const openMin = openH * 60 + openM;
    const closeMin = closeH * 60 + closeM;

    if(nowMin < openMin) {
        return { label: `Закрыто до ${openStr}`, isOpen: false };
    }

    if(nowMin >= closeMin) {
        return { label: 'Закрыто', isOpen: false };
    }

    return { label: `Открыто до ${closeStr}`, isOpen: true };
}